import { IonGrid, IonRow, IonCol } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import {Controller, useForm} from "react-hook-form";
import { selectCount } from "../../../store/formsubmitted/selectors/selectCount";
import {IonButton, IonInput, IonItem, IonLabel, IonSpinner} from "@ionic/react";
import { findLegalReps } from "../../../store/massiveDocumentCreate/actions/findLegalRep";
import { getSignatureProviders } from "../../../store/signatureProviders/actions/getSignatureProviders";
import { selectTemplateDetail } from "../../../store/templateDetail/selectors/selectTemplateDetail";
import { findTemplates } from "../../../store/templateList/actions/findTemplates";
import { FileTemplateInputsContainer } from "./FileTemplateInputsContainer";
import { FileTemplateUpdateHelperContainer } from "./FileTemplateUpdateHelperContainer";
import { Template } from "../../../@types/template";
import { ArchiveViewer } from "../../../components/ArchiveViewer";
import { useRef } from 'react';
import {createArchive} from "../../../store/documentCreate/actions/createArchiveBasic";
import {createFileTemplate} from "../../../store/templateCreate/actions/createFileTemplate";
import {updateFileTemplate} from "../../../store/templateCreate/actions/updateFileTemplate";
import { useParams } from "react-router";


export const FileTemplateFormContainer: React.FC<{ template?: Template }> = ({ template: templateFromProps }) => {
  const templateFromStore = useSelector(selectTemplateDetail);
  const template = templateFromProps || templateFromStore;
  const archive = (template as any)?.archive; // expects { id, filename, extension, path }
  const counter = useSelector(selectCount);
  const dispatch = useDispatch();
  const { id: templateId } = useParams<{ id: string }>();

  const fileInput = useRef<HTMLInputElement>(null)
  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    formState: {errors},
  } = useForm({
    defaultValues: {
      creationType: '',
      name: "",
      archive: null,
      archiveFilename: ''
    },
  });

  const onFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) {

      try {
        //Subir archivo
        const response = await dispatch<any>(createArchive(file))
        if (response?.payload) {
          setValue('archive', response.payload)
          setValue('archiveFilename', file.name)
        }
      //Asociarlo con plantilla

        await dispatch<any>(
          updateFileTemplate({
            id: templateId,
            changes: { archive: response.payload.id },
          })
        );

      } finally {

      }
    }
  }

  return (
    <IonGrid>
      {archive && (
        <>
        <IonRow>
          <IonCol>
            <IonItem lines="inset" onClick={() => fileInput?.current?.click()} button>
              <IonLabel position="stacked">Archivo PDF</IonLabel>
              <Controller
                name="archiveFilename"
                control={control}
                rules={{
                  validate: () => {
                    const archivoNombre = watch('archiveFilename');
                    if (!archivoNombre) return 'Debe seleccionar un archivo PDF.';
                    return true;
                  }
                }}
                render={({ field: { value } }: any) => (
                  <>
                    <input ref={fileInput} type="file" accept="application/pdf" onChange={onFileChange} hidden />
                    <IonInput
                      value={value}
                      placeholder="Seleccionar archivo para modificar"
                      readonly
                    />
                  </>
                )}
              />
            </IonItem>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size="12">
            <ArchiveViewer archive={archive} />
          </IonCol>
        </IonRow>
        </>
      )}

    </IonGrid>
  );
};
